webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(43);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Startup = __webpack_require__(31);
	
	var _Startup2 = _interopRequireDefault(_Startup);
	
	var _Corporate = __webpack_require__(24);
	
	var _Corporate2 = _interopRequireDefault(_Corporate);
	
	var _Map = __webpack_require__(28);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Smart = __webpack_require__(30);
	
	var _Smart2 = _interopRequireDefault(_Smart);
	
	var _About = __webpack_require__(23);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Future = __webpack_require__(25);
	
	var _Future2 = _interopRequireDefault(_Future);
	
	var _Privacy = __webpack_require__(29);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _Impressum = __webpack_require__(27);
	
	var _Impressum2 = _interopRequireDefault(_Impressum);
	
	var _App = __webpack_require__(22);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(42);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueHead = __webpack_require__(21);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueHead2.default);
	_vue2.default.use(_vueRouter2.default);
	var routes = [{ path: '/startup-innovation', component: _Startup2.default }, { path: '/corporate-innovation', component: _Corporate2.default }, { path: '/smart-energy-systems', component: _Smart2.default }, { path: '/future-energy-system', component: _Future2.default }, { path: '/contact-about', component: _About2.default }, { path: '/cleantech-startup-map', component: _Map2.default }, { path: '/impressum', component: _Impressum2.default }, { path: '/privacy', component: _Privacy2.default }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes
	});
	
	new _vue2.default({
	  router: router,
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hello = __webpack_require__(26);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Hello: _Hello2.default
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Contact | About'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Corporate Innovation'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Future Energy System'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello'
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Impressum'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Datenschutz'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Smart Energy Systems'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    back: function back() {
	      window.history.go(-1);
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Start-Up Innovation'
	    };
	  },
	
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'description', content: 'My description', id: 'desc' }]
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 17 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(14)
	
	/* script */
	__vue_exports__ = __webpack_require__(1)
	
	/* template */
	var __vue_template__ = __webpack_require__(35)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(12)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(33)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(19)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(40)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(15)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(36)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(18)
	
	/* script */
	__vue_exports__ = __webpack_require__(5)
	
	/* template */
	var __vue_template__ = __webpack_require__(39)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(16)
	
	/* script */
	__vue_exports__ = __webpack_require__(6)
	
	/* template */
	var __vue_template__ = __webpack_require__(37)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(20)
	
	/* script */
	__vue_exports__ = __webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(41)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(11)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(32)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(13)
	
	/* script */
	__vue_exports__ = __webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(34)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(17)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(38)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('h2', ["Datenschutz / Privacy"]), " ", _h('p', ["Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten\n        (Emailadressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf\n        ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist – soweit\n        technisch möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder\n        eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben\n        veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie Emailadressen durch Dritte\n        zur Übersendung von nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte\n        gegen die Versender von sogenannten Spam-Mails bei Verstössen gegen dieses Verbot sind ausdrücklich\n        vorbehalten.\n        Diese Webseite benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“). Google Analytics\n        verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die die Analyse der\n        Benutzung der Webseite durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre\n        Benutzung dieser Webseite (einschließlich Ihrer IP-Adresse) werden an einen Server von Google in den USA\n        übertragen und dort gespeichert. Google wird diese Informationen benutzen, um die Nutzung der Webseite\n        auszuwerten, um Reports über die Webseitenaktivitäten für die Webseitenbetreiber zusammenzustellen und um\n        weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Außerdem\n        wird Google diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben\n        oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Diese Website nutzt die\n        Google-Analytics-Berichte zu demografischen Merkmalen, in denen Daten aus interessenbezogener Werbung von\n        Google sowie Besucherdaten von Drittanbietern (z. B. Alter, Geschlecht und Interessen) verwendet werden.\n        Diese Daten sind nicht auf eine bestimmte Person zurückzuführen und können jederzeit über die\n        Anzeigeneinstellungen deaktiviert werden. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten von\n        Google in Verbindung bringen. Sie können die Installation der Cookies durch eine entsprechende Einstellung\n        Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls\n        nicht sämtliche Funktionen dieser Website vollumfänglich nutzen können. Durch die Nutzung dieser Webseite\n        erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen\n        Art und Weise und zu dem zuvor benannten Zweck einverstanden. Sie können die Erfassung durch Google\n        Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die\n        zukünftige Erfassung Ihrer Daten beim Besuch dieser Website verhindert:"]), " ", _h('a', {
	    attrs: {
	      "onclick": "alert('Google Analytics wurde deaktiviert');",
	      "href": "javascript:gaOptout()"
	    }
	  }, ["Google Analytics deaktivieren"]), " ", _h('p', {
	    staticClass: "end"
	  })])
	}}]}

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('h2', ["Contact"]), " ", _h('p', ["Have we awoken your interest? If so, then please feel free to get in touch with us to work on a ", _h('span', {
	    staticClass: "versa"
	  }, ["GREEN"]), "\n        future."]), " ", _h('p', [" Dipl. Wi.-Ing. Christian Huder"]), " ", _h('p', ["hello@innergy.berlin"]), " ", _h('h2', {
	    staticClass: "after"
	  }, ["About"]), " ", _h('p', [_h('span', {
	    staticClass: "versa"
	  }, ["BERLIN"]), " offers a very ", _h('span', {
	    staticClass: "versa"
	  }, ["UNIQUE ECOSYSTEM"]), " to support and encourage ", _h('span', {
	    staticClass: "versa"
	  }, ["ENTREPRENEURSHIP"]), ". There is hardly any other\n        city in the world, that provides such a matchless ecosystem: political stability, access to finance, strong\n        national markets and a city which is still under development after its reunification in 1989, providing lots\n        of affordable, open spaces in the city centre for new ideas and creative people. This especially attracts\n        ", _h('span', {
	    staticClass: "versa"
	  }, ["DIVERSE PEOPLE"]), " from all over the world, who dive into the urban space to explore alternative ways of living\n        apart from the standard capitalism which obviously does not do a good job in protecting our planet. This\n        ecosystem is supported and amplified by an extremely wide range of cultural activities. At the same time\n        there are very good social security instruments in place and only few governmental limitations hinder the\n        evolution of individuals."]), " ", _h('p', ["This way of living has also produced a broad consent, that ", _h('span', {
	    staticClass: "versa"
	  }, ["ECONOMIES"]), " must operate ", _h('span', {
	    staticClass: "versa"
	  }, ["SUSTAINABLY"]), " and need to\n        protect our environment and climate in order to ensure a positive growth of society in the future."]), " ", _h('p', ["Combining this, with Germany`s leading position in building and operating renewable energies, Berlin is\n        clearly a singular place for ", _h('span', {
	    staticClass: "versa"
	  }, ["CLEANTECH INNOVATION"]), " and entrepreneurship. Current investment rates into Berlin\n        start-ups back this observation: in the first half of 2015 it surpassed already €1.5 bn and thereby achieved\n        the highest investment rate in Europe", _h('span', {
	    staticClass: "reference"
	  }, ["1"]), ". But this does not make other\n        innovation centres around the world less attractive, which is why we cultivated a strong ", _h('span', {
	    staticClass: "versa"
	  }, ["NETWORK"]), " across\n        Europe and to the Silicon Valley."]), " ", _h('p', {
	    staticClass: "footnote"
	  }, ["(1) ", _h('a', {
	    attrs: {
	      "href": "//www.ey.com/DE/de/Newsroom/News-releases/EY-20150827-Berlin-ist-Europas-Start-up-Hauptstadt",
	      "target": "_blank"
	    }
	  }, ["Ey –\n        Start-up-Barometer Deutschland"])])])
	}}]}

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('h2', ["Smart Energy Systems"]), " ", _h('p', ["Energy systems will become smart to meet the requirement of a stable electricity supply even when the energy\n        sources, such as wind- and solar power, are highly volatile. This will enable a 100% electricity supply by\n        ", _h('span', {
	    staticClass: "versa"
	  }, ["RENEWABLE ENERGIES"]), " for most countries in the world. Furthermore smart energy\n        systems are needed to make the overall system more ", _h('span', {
	    staticClass: "versa"
	  }, ["EFFICIENT"]), " in order to reduce use\n        of resources and capital.\n        To achieve this, smart devices are necessary to interconnect renewable energies with the grid operation and\n        ", _h('span', {
	    staticClass: "versa"
	  }, ["SMART CONSUMERS"]), ". Smart consumers will be especially large ", _h('span', {
	    staticClass: "versa"
	  }, ["INDUSTRIAL"]), " or ", _h('span', {
	    staticClass: "versa"
	  }, ["COMMERCIAL"]), " facilities, ", _h('span', {
	    staticClass: "versa"
	  }, ["ELECTRIC VEHICLES"]), " and other types\n        of ", _h('span', {
	    staticClass: "versa"
	  }, ["STORAGE"]), " [Not the so called smart meter for end customers]. The matching of\n        supply and demand for energy will happen automatically and will not involve a change of usage patterns for\n        end customers. Thereby it also constitutes the first complete application case of the ", _h('span', {
	    staticClass: "versa"
	  }, ["Digitalization"]), "\n        of a whole industry.\n      "]), " ", _h('p', ["To foster the introduction of ", _h('span', {
	    staticClass: "versa"
	  }, ["SMART ENERGY SYSTEMS"]), " we provide consulting solutions\n        for the following\n        areas:"]), " ", _h('ul', [_h('li', ["Industrial Micro Smart Grids – Renewable, reliable and sustainable onsite generation"]), " ", _h('li', ["Economic optimization of industrial energy consumption"]), " ", _h('li', ["Energy management solutions"]), " ", _h('li', ["Future energy system and market design for 100% renewables"])]), " ", _h('h2', ["Smart Energy project activity"]), " ", _h('ul', {
	    staticClass: "years"
	  }, [_h('li', [_h('span', ["2015"]), "Organization of ", _h('a', {
	    attrs: {
	      "href": "//www.eitdigital.eu/sec2015/",
	      "target": "_blank"
	    }
	  }, ["Smart Energy Community\n          Conference"])]), " ", _h('li', [_h('span', ["2014-2015"]), "Development of a decentralized energy supply strategy for a large industrial\n          consumer in the context of the “Energiewende” (Industrial Micro Smart Grids) – incl. flexible energy\n          management platform for multiple use cases\n        "]), " ", _h('li', [_h('span', ["2014"]), "Co-founder of ", _h('a', {
	    attrs: {
	      "href": "//www.eitdigital.eu/innovation-entrepreneurship/smart-energy-systems/smart-energy-community-2014/",
	      "target": "_blank"
	    }
	  }, ["Smart\n          Energy Community Conference"])]), " ", _h('li', [_h('span', ["2013"]), "Project lead of ", _h('a', {
	    attrs: {
	      "href": "//www.youtube.com/watch?v=-HesDRfiiKo",
	      "target": "_blank"
	    }
	  }, ["“Speicherstudie”"]), " -\n          a project to connect large uninterruptable power supply systems of a telecommunication provider to the\n          frequency control of a large utility\n        "]), " ", _h('li', [_h('span', ["2012"]), "Development of the pan European business area ", _h('a', {
	    attrs: {
	      "href": "//www.eitdigital.eu/innovation-entrepreneurship/smart-energy-systems/",
	      "target": "_blank"
	    }
	  }, ["Smart Energy\n          Systems"]), " for EIT Digital\n          together with the leading European research institutes, universities and industry actors\n        "]), " ", _h('li', [_h('span', ["2010"]), "Smart Metering & Smart Grid in Germany – Technology Roadmap until 2020"])]), " ", _h('p', {
	    staticClass: "end"
	  })])
	}}]}

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('hello')])
	}},staticRenderFns: []}

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('h2', ["Future Energy System"]), " ", _h('p', ["To bring ", _h('span', {
	    staticClass: "versa"
	  }, ["INNOVATION"]), " to life it is necessary to imagine a different future for our energy system. By\n        scrutinizing the current system one can imagine how a ", _h('span', {
	    staticClass: "versa"
	  }, ["FUTURE ENERGY SYSTEM"]), " may look:"]), " ", _h('p', ["Imagine it is 2035 and ", _h('span', {
	    staticClass: "versa"
	  }, ["RENEWABLE ENERGY"]), " generation has surpassed 90% of overall electricity generation. This\n        means the system is running without hardly any ", _h('span', {
	    staticClass: "versa"
	  }, ["FUEL"]), ". Almost no coal, gas or other fuels are needed anymore\n        which means in correlation that the operational costs of the energy system decrease massively. They now\n        mainly consist of maintaining the system and repowering old or broken assets.\n        The power generation happens almost everywhere through decentralized photovoltaic and wind power plants."]), " ", _h('p', ["If a region suffers from missing wind or sun, the energy can be routed in large ", _h('span', {
	    staticClass: "versa"
	  }, ["CAPACITIES"]), " from one region to\n        another by utilizing the newly-built high voltage lines. They have been built according to the network\n        development plan of the Bundesnetzagentur, conceived in 2015. The new lines have been financed by fees on\n        each consumed kWh over a period of almost 20 years.\n        The need to automatically balance supply and demand for electricity made the energy system the ultimate\n        application case for the ", _h('span', {
	    staticClass: "versa"
	  }, ["Digitalization"]), " wave of the late 2010`s. As a result, the whole electricity industry\n        has been successfully digitalized and works almost autonomously."]), " ", _h('p', ["Such a system has, after all, one large consequence: Once in place, its operational ", _h('span', {
	    staticClass: "versa"
	  }, ["COST"]), "s are very ", _h('span', {
	    staticClass: "versa"
	  }, ["LOW"]), ". This\n        allows us to draw comparisons with the telecommunication network. Once sufficient network capacity has been\n        installed by the introduction of fibers, flatrates have been born."]), " ", _h('p', ["Does that mean, we will at some point have an energy ", _h('span', {
	    staticClass: "versa"
	  }, ["FLATRATE"]), "? Yes, certainly we think so. A flatrate paid by\n        the maximum line capacity similar to today`s internet connections.\n        And this raises a number of open question:"]), " ", _h('ul', [_h('li', ["What kind of regulation is needed for such a system?"]), " ", _h('li', ["What kind of market design is needed?"]), " ", _h('li', ["What kind of communication technology is needed to drive the ", _h('span', {
	    staticClass: "versa"
	  }, ["DIGITALISATION"]), "?"]), " ", _h('li', ["Who are the market actors and what does the value chain look like?"])]), " ", _h('p', ["We imagine such a future and attempt to answer these questions already today. Has this awoken your interest?\n        If so, then please feel free to get in touch with us to work on the Energy System of the Future: ", _h('span', {
	    staticClass: "versa"
	  }, ["RELIABLE.\n          AFFORDABLE. SUSTAINABLE"]), ". \n      "]), " ", _h('div', {
	    staticClass: "footnote"
	  }, [_h('ul', ["Further readings:\n          ", _h('li', ["(1) ", _h('a', {
	    attrs: {
	      "href": "//www.energiewendebeschleunigen.de/megatrends/",
	      "target": "_blank"
	    }
	  }, ["WWF & Lichtblick – Megatrends der globalen\n            Energiewende {2015} "])]), " ", _h('li', ["(2) ", _h('a', {
	    attrs: {
	      "href": "//www.nytimes.com/2014/04/18/opinion/krugman-salvation-gets-cheap.html?ref=paulkrugman&_r=1",
	      "target": "_blank"
	    }
	  }, ["Paul\n            Krugmann – Salvation Gets Cheap {2014}"])]), " ", _h('li', ["(3) ", _h('a', {
	    attrs: {
	      "href": "//energy.gov/sites/prod/files/2013/09/f2/Revolution%20Now%20--%20The%20Future%20Arrives%20for%20Four%20Clean%20Energy%20Technologies.pdf",
	      "target": "_blank"
	    }
	  }, ["U.S.\n            Department of Energy – Revolution Now {2013}"])]), " ", _h('li', ["(4) ", _h('a', {
	    attrs: {
	      "href": "//www.thezeromarginalcostsociety.com",
	      "target": "_blank"
	    }
	  }, ["Jeremy Rifkin – The Zero Marginal Cost Society\n            {2014}"])]), " ", _h('li', ["(5) ", _h('a', {
	    attrs: {
	      "href": "http://www.netzausbau.de/EN/home/en.html",
	      "target": "_blank"
	    }
	  }, ["Creating Future-Proof Network – Bundesnetzagentur\n            {2015}"])])])]), " ", _h('p', {
	    staticClass: "end"
	  })])
	}}]}

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('div', {
	    staticClass: "cleanmap"
	  }, [_h('h2', ["Impressum"]), " ", _h('p', ["Christian Huder", _h('br'), "\n          Rudolfstraße 10", _h('br'), "\n          10245 Berlin"]), " ", _h('h3', ["Contact"]), " ", _h('p', ["email: hello@innergy.berlin", _h('br'), "\n          phone: (49) 3068322626"])])])
	}}]}

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('h2', ["Start-up Innovation"]), " ", _h('p', [_h('span', {
	    staticClass: "versa"
	  }, ["Start-ups"]), " can be a very efficient way to transform ideas or technology into marketable products or life saving innovation when thinking about the protection of our environment. ", _h('span', {
	    staticClass: "versa"
	  }, ["Corporations"]), " often lack the ability to\n        innovate and change fundamentally whereas start-ups can quickly adopt new approaches, mindsets and\n        requirements from a globalized world. One of these requirements is to live in harmony with our ", _h('span', {
	    staticClass: "versa"
	  }, ["Environment"]), "\n        whilst at the same time maintaining our standards of living. ", _h('span', {
	    staticClass: "versa"
	  }, ["Technology"]), " and ", _h('span', {
	    staticClass: "versa"
	  }, ["Start-ups"]), " can help overcome the\n        current gap."]), " ", _h('p', ["Therefore we support the development of ", _h('span', {
	    staticClass: "versa"
	  }, ["Cleantech"]), " start-ups in many ways:"]), " ", _h('ul', [_h('li', ["Mentoring"]), " ", _h('li', ["Business Modelling"]), " ", _h('li', ["Financing"]), " ", _h('li', ["Energy Regulation"])]), " ", _h('h2', ["START-UP accelerator & contest activity"]), " ", _h('ul', {
	    staticClass: "years"
	  }, [_h('li', [_h('span', ["2013-2015"]), "Organization support & ", _h('a', {
	    attrs: {
	      "href": "//www.youtube.com/user/StartupNightBerlin/feed?activity_view=1",
	      "target": "_blank"
	    }
	  }, ["moderation"]), " Start-up Night Berlin (", _h('a', {
	    attrs: {
	      "href": "//www.startupnight.de/"
	    }
	  }, ["Lange Nacht der Startups"]), ")\n        "]), " ", _h('li', [_h('span', ["2015"]), "Jury member ", _h('a', {
	    attrs: {
	      "href": "//www.incense-accelerator.com/",
	      "target": "_blank"
	    }
	  }, ["INCENSe"]), " Accelerator"]), " ", _h('li', [_h('span', ["2015"]), "Jury member and mentor ", _h('a', {
	    attrs: {
	      "href": "//www.climate-kic.org/national-centres/berlin-germany/green-garage/",
	      "target": "_blank"
	    }
	  }, ["Climate KIC Green Garage Accelerator"])]), " ", _h('li', [_h('span', ["2015"]), "Mentor ", _h('a', {
	    attrs: {
	      "href": "//cleantech-innovationcenter.de/",
	      "target": "_blank"
	    }
	  }, ["Clean Tech Innovation Center"])]), " ", _h('li', [_h('span', ["2014"]), "Jury member ", _h('a', {
	    attrs: {
	      "href": "//www.eitdigital.eu/idea-challenge/about/",
	      "target": "_blank"
	    }
	  }, ["EIT Digital Idea Challenge"]), " Smart Energy Systems"]), " ", _h('li', [_h('span', ["2013"]), "Jury member ", _h('a', {
	    attrs: {
	      "href": "//www.telekom-innovation-contest.com/",
	      "target": "_blank"
	    }
	  }, ["Telekom Innovation Contest Smart Energy Systems"])])]), " ", _h('p', {
	    staticClass: "end"
	  })])
	}}]}

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [_h('section', {
	    staticClass: "main"
	  }, [_m(0), " ", _h('div', {
	    staticClass: "board"
	  }, [_h('nav', [_h('router-link', {
	    staticClass: "tile",
	    attrs: {
	      "to": "startup-innovation"
	    }
	  }, [_h('svg', [_h('use', {
	    attrs: {
	      "xlink:href": "#rocket"
	    }
	  })]), " ", _m(1)]), " ", _h('router-link', {
	    staticClass: "tile",
	    attrs: {
	      "to": "corporate-innovation"
	    }
	  }, [_h('svg', [_h('use', {
	    attrs: {
	      "xlink:href": "#train"
	    }
	  })]), " ", _m(2)]), " ", _h('router-link', {
	    staticClass: "tile",
	    attrs: {
	      "to": "smart-energy-systems"
	    }
	  }, [_h('svg', [_h('use', {
	    attrs: {
	      "xlink:href": "#grid"
	    }
	  })]), " ", _m(3)]), " ", _h('router-link', {
	    staticClass: "tile",
	    attrs: {
	      "to": "future-energy-system"
	    }
	  }, [_h('svg', [_h('use', {
	    attrs: {
	      "xlink:href": "#circle"
	    }
	  })]), " ", _m(4)]), " ", _h('router-link', {
	    staticClass: "tile",
	    attrs: {
	      "to": "cleantech-startup-map"
	    }
	  }, [_h('svg', [_h('use', {
	    attrs: {
	      "xlink:href": "#map"
	    }
	  })]), " ", _m(5)]), " ", _h('router-link', {
	    staticClass: "tile",
	    attrs: {
	      "to": "contact-about"
	    }
	  }, [_h('svg', [_h('use', {
	    attrs: {
	      "xlink:href": "#bubble"
	    }
	  })]), " ", _m(6)])]), " ", _h('router-view')])]), " ", _m(7), " ", _m(8)])
	}},staticRenderFns: [function (){with(this) {
	  return _h('header', [_h('h1', ["Innovation with Energy."])])
	}},function (){with(this) {
	  return _h('div', [_h('h2', ["Start-up Innovation"])])
	}},function (){with(this) {
	  return _h('div', [_h('h2', ["Corporate Innovation"])])
	}},function (){with(this) {
	  return _h('div', [_h('h2', ["Smart Energy Systems"])])
	}},function (){with(this) {
	  return _h('div', [_h('h2', ["Future Energy System"])])
	}},function (){with(this) {
	  return _h('div', [_h('h2', ["Cleantech Startup Map"])])
	}},function (){with(this) {
	  return _h('div', [_h('h2', ["Contact | About"])])
	}},function (){with(this) {
	  return _h('section', {
	    attrs: {
	      "id": "partners"
	    }
	  }, [_h('h3', ["Clients and partners"]), " ", _h('div', {
	    staticClass: "partners"
	  }, [_h('a', {
	    attrs: {
	      "href": "//www.rwe.de",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "rwe-innovation",
	    attrs: {
	      "alt": "RWE Innovation Hub",
	      "title": "RWE Innovationhub",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.enel.it",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "enel",
	    attrs: {
	      "alt": "Enel",
	      "title": "Enel",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.laboratories.telekom.com",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "telekominnovation",
	    attrs: {
	      "alt": "Telekom Innovation Labs",
	      "title": "Telekom Innovation Labs",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.dena.de",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "dena",
	    attrs: {
	      "alt": "Dena",
	      "title": "Dena",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.startupnight.de",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "langenacht",
	    attrs: {
	      "alt": "Lange Nacht der Startups",
	      "title": "Lange Nacht der Startups",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.climate-kic.org",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "eitclimate",
	    attrs: {
	      "alt": "EIT Climate kic",
	      "title": "EIT Climate kic",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.hubraum.com",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "hubraum",
	    attrs: {
	      "alt": "hubraum",
	      "title": "hubraum",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.entrepreneurship.tu-berlin.de",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "cfe",
	    attrs: {
	      "alt": "CfE Logo",
	      "title": "Centre for Entrepreneurship",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.incense-accelerator.com",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "incense",
	    attrs: {
	      "alt": "Incense Energy Accelerator",
	      "title": "Incense Energy Accelerator",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//cleantechpark.de",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "cleantech",
	    attrs: {
	      "alt": "Cleantech Businesspark Berlin-Marzahn",
	      "title": "Cleantech Businesspark Berlin-Marzahn",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.eitdigital.eu/idea-challenge/about/",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "ideachallenge",
	    attrs: {
	      "alt": "EIT Idea Challenge",
	      "title": "EIT Idea Challenge",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.rohrbeckheger.com",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "rohrbeckheger",
	    attrs: {
	      "alt": "Rohrbeck Heger GmbH",
	      "title": "Rohrbeck Heger GmbH",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.eitdigital.eu",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "eitdigital",
	    attrs: {
	      "alt": "EIT Digital Logo",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })]), " ", _h('a', {
	    attrs: {
	      "href": "//www.vattenfall.de",
	      "target": "_blank"
	    }
	  }, [_h('img', {
	    staticClass: "vattenfall",
	    attrs: {
	      "alt": "vattenfall",
	      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
	    }
	  })])])])
	}},function (){with(this) {
	  return _h('footer', [_h('ul', [_h('li', [_h('a', {
	    attrs: {
	      "href": "impressum"
	    }
	  }, ["Impressum"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "privacy"
	    }
	  }, ["Datenschutz"])])])])
	}}]}

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('h2', ["Corporate Innovation"]), " ", _h('p', ["We deeply believe in the power of world-changing ", _h('span', {
	    staticClass: "versa"
	  }, ["INNOVATION"]), ". Especially the ", _h('span', {
	    staticClass: "versa"
	  }, ["CLEANTECH"]), " sector has proven in\n        recent years, that it is possible to change the world with innovation through its enormous success of\n        improving ", _h('span', {
	    staticClass: "versa"
	  }, ["PHOTOVOLTAIK"]), " and ", _h('span', {
	    staticClass: "versa"
	  }, ["WIND"]), " power products while decreasing its costs massively.\n        Therefore we try to live innovation every day, by constantly scrutinizing the current state of mind and\n        continuously working on improving a given system. To make innovation become reality we apply proven methods\n        and explore new paths to support the development of new processes, ideas or products. Thereby ", _h('span', {
	    staticClass: "versa"
	  }, ["START-UPS"]), " can\n        very well complement the innovation portfolio of ", _h('span', {
	    staticClass: "versa"
	  }, ["CORPORATIONS"]), "."]), " ", _h('p', [" We provide the following services to boost your innovation capabilities and transform your business for a ", _h('span', {
	    staticClass: "versa"
	  }, ["GREEN"]), " future:\n      "]), " ", _h('ul', [_h('li', ["Strategic Foresight (Innovation Radar and Strategic Roadmapping)"]), " ", _h('li', ["Innovation Exploration and corporate/ start-up matching"]), " ", _h('li', ["Start-up scouting and evaluation"]), " ", _h('li', ["Innovation Contests and Hackathons"]), " ", _h('li', ["Intrapreneurship and Accelerator programs"])]), " ", _h('h2', ["Corporate project activity"]), " ", _h('ul', {
	    staticClass: "years"
	  }, [_h('li', [_h('span', ["2015"]), _h('a', {
	    attrs: {
	      "href": "//www.rohrbeckheger.com/work/innovation-exploration/",
	      "target": "_blank"
	    }
	  }, ["Innovation Exploration"]), " for a major corporate"]), " ", _h('li', [_h('span', ["2015"]), "IT tool based innovation radar for a major corporate in the energy and resource sector\n        "]), " ", _h('li', [_h('span', ["2014"]), "Co-organization of a ", _h('a', {
	    attrs: {
	      "href": "//www.laboratories.telekom.com/public/deutsch/newsroom/news/pages/t-labs-verleihen-sonderpreis-smart-energy-fuer-whats-my-carbon.aspx",
	      "target": "_blank"
	    }
	  }, ["Hackathon"]), " with Berlin ", _h('a', {
	    attrs: {
	      "href": "//www.geekettes.io/",
	      "target": "_blank"
	    }
	  }, ["Geekettes"]), " for SAP"]), " ", _h('li', [_h('span', ["2013"]), "Development and organization of a innovation contest for a large corporate"]), " ", _h('li', [_h('span', ["2012"]), _h('a', {
	    attrs: {
	      "href": "//papers.ssrn.com/sol3/papers.cfm?abstract_id=2197724",
	      "target": "_blank"
	    }
	  }, ["Smart Energy Working Group"]), " workshop based development of new business models with 8\n          utilities\n        "]), " ", _h('li', [_h('span', ["2011"]), "Innovation Radar Energy for a major utility"])]), " ", _h('p', {
	    staticClass: "end"
	  })])
	}}]}

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay"
	  }, [_h('div', {
	    staticClass: "overlay-content"
	  }, [_h('a', {
	    staticClass: "overlay-close",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": back
	    }
	  }, ["✕"]), " ", _m(0)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "overlay-inner"
	  }, [_h('div', {
	    staticClass: "cleanmap"
	  }, [_h('h2', ["Cleantech Startup Map"]), " ", _h('p', ["The Cleantech Startup Map will soon be available."])])])
	}}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.a1c4d9a55eb28dacb1f5.js